export const API_ENDPOINTS = {
  // AUTH ENDPOINTS
  LOGIN: '/api/admin/login',
  RESEND_OTP: '/api/admin/resend-otp',
  VERIFY_OTP: '/api/admin/verify-otp',
  CHANGE_PASSWORD: '/api/admin/change-password',
  FORGET_PASSWORD: '/api/admin/request-password-reset',

  // FILE UPLOAD ENDPOINTS
  GET_STATES: '/api/get-states',
  GET_CITIES: '/api/get-cities',
  GET_STATE_CITIES: '/api/get-state-cities',
  FILE_UPLOAD: '/api/admin/update-profile-picture',

  // AUTH APPLICANT ENDPOINTS
  SIGN_UP: '/api/register',
  APPLICANT_LOGIN: '/api/login',
  GET_POSITIONS: '/api/positions',
  APPLICANT_RESEND_OTP: '/api/resend-otp',
  APPLICANT_VERIFY_OTP: '/api/verify-otp',
  APPLICANT_CHANGE_PASSWORD: '/api/change-password',
  APPLICANT_FORGET_PASSWORD: '/api/request-password-reset',

  // PROFILE APPLICANT ENDPOINTS
  APPLICANT_UPDATE_PROFILE: '/api/update-profile',
  APPLICANT_GET_PROFILE_DETAILS: '/api/get-user-detail',
  APPLICANT_ADD_EMPLOYMENT_GAP: '/api/employment-history-gap',
  APPLICANT_ADD_EMPLOYMENT_HISTORY: '/api/employment-history',
  APPLICANT_UPDATE_EDUCATION_HISTORY: '/api/education-history',
  APPLICANT_UPDATE_EMPLOYMENT_HISTORY: '/api/employment-history',

  // PROFILE ENDPOINTS
  VIEW_PROFILE: '/api/get-profile',
  TOGGLE_2FA: '/api/admin/toggle-2fa',
  UPDATE_PROFILE: '/api/admin/update-profile',
  ACCOUNT_CHANGE_PASSWORD: '/api/account-change-password',

  // ORGANIZATION ENDPOINTS
  ADD_ORGANIZATION_DETAILS: '/api/organization',
  VIEW_ORGANIZATION_DETAILS: '/api/organization',
  UPDATE_ORGANIZATION_DETAILS: '/api/organization',

  //LEAD SOURCE ENDPOINTS
  GET_LEAD_SOURCE: '/api/lead-source',
  CREATE_LEAD_SOURCE: '/api/lead-source',
  DELETE_LEAD_SOURCE: '/api/lead-source',
  UPDATE_LEAD_SOURCE: '/api/lead-source',

  // ROLE MANAGEMENT ENDPOINTS
  GET_ROLE: '/api/role',
  CREATE_ROLE: '/api/role',
  DELETE_ROLE: '/api/role',
  UPDATE_ROLE: '/api/role',

  // PERMISSION ENDPOINTS
  GET_PERMISSION: '/api/permission',
  CREATE_PERMISSION: '/api/permission',
  DELETE_PERMISSION: '/api/permission',
  UPDATE_PERMISSION: '/api/permission',

  // POSITION ENDPOINTS
  GET_POSITION: '/api/positions',
  CREATE_POSITION: '/api/positions',
  DELETE_POSITION: '/api/positions',
  UPDATE_POSITION: '/api/positions',
  ACTIVE_INACTIVE_POSITION: '/api/positions/toggle-status',

  // CATEGORIES ENDPOINTS
  GET_CATEGORIES: '/api/category',
  CREATE_CATEGORY: '/api/category',
  UPDATE_CATEGORY: '/api/category',
  DELETE_CATEGORY: '/api/category',
  ACTIVE_INACTIVE_CATEGORY: '/api/category/toggle-status',

  // DOCUMENTS ENDPOINTS
  DELETE_DOCUMENT: '/api/documents/category',
  UPDATE_DOCUMENT: '/api/documents/category',
  GET_DOCUMENTS: '/api/documents/get-category',
  CREATE_DOCUMENT: '/api/documents/add-category',
  ACTIVE_INACTIVE_DOCUMENT: '/api/documents/category/toggle-status',

  // USER MANAGEMENT ENDPOINTS
  GET_USER: '/api/organizationUser',
  DELETE_USER: '/api/organizationUser',
  UPDATE_USER: '/api/organizationUser/update-user',
  CREATE_USER: '/api/organizationUser/registerUser',
  ACTIVE_INACTIVE_USER: '/api/organizationUser/toggle-staus',
  USER_SET_PASSWORD: '/api/organizationUser/change-password',

  // COMPETENCY TEST ENDPOINTS
  GET_TEST: '/api/competency-test',
  DELETE_TEST: '/api/competency-test',
  UPDATE_TEST: '/api/competency-test',
  CREATE_TEST: '/api/competency-test',
  SOFT_DELETE_TEST: '/api/competency-test/soft-delete',
  GET_TEST_BY_USER: '/api/competency-test/test-by-user',
  ADD_TEST_QUESTION: '/api/competency-test/add-question',

  // EVALUATION TEST ENDPOINTS
  GET_EVALUATION: '/api/evaluation',
  DELETE_EVALUATION: '/api/evaluation',
  UPDATE_EVALUATION: '/api/evaluation',
  CREATE_EVALUATION: '/api/evaluation',
  SOFT_DELETE_EVALUATION: '/api/evaluation/soft-delete',
  ADD_EVALUATION_QUESTION: '/api/evaluation/add-question',
  GET_EVALUATION_BY_USER: '/api/evaluation/evaluation-test',
  ADD_EVALUATION_ANSWER_USER: '/api/evaluation/evaluation-answer',
  EVALUATION_SEND_REMINDER: '/api/evaluation/send-evalation-reminder',

  // CALENDAR EVENTS ENDPOINTS
  GET_EVENTS: '/api/event-management',
  CREATE_EVENTS: '/api/event-management',
  DELETE_EVENTS: '/api/event-management',
  UPDATE_EVENTS: '/api/event-management',
  GET_EMPLOYEES: '/api/event-management/employees',

  // SKILL CHECKLISTS ENDPOINTS
  GET_SKILL_CHECKLIST: '/api/skill-checklist',
  DELETE_SKILL_CHECKLIST: '/api/skill-checklist',
  UPDATE_SKILL_CHECKLIST: '/api/skill-checklist',
  CREATE_SKILL_CHECKLIST: '/api/skill-checklist',
  CREATE_GROUP_CHECKLIST: '/api/skill-checklist/addgroup',
  GET_SKILL_CHECKLIST_BY_USER: '/api/skill-checklist/answers',
  CREATE_SCALING_CHECKLIST: '/api/skill-checklist/questiontype',
  SOFT_DELETE_SKILL_CHECKLIST: '/api/skill-checklist/softDelete',

  //REFERENCE FORM ENDPOINTS
  GET_REFERENCE_FORM: '/api/reference-form',
  DELETE_REFERENCE_FORM: '/api/reference-form',
  UPDATE_REFERENCE_FORM: '/api/reference-form',
  CREATE_REFERENCE_FORM: '/api/reference-form',
  ADD_REFERENCE_FORM_QUESTION: '/api/reference-form/add-question',

  //COMPLIANCE MANAGER REQUIREMENT ENDPOINTS
  GET_COMPLIANCE_REQUIREMENT: '/api/compliance-requirement',
  UPDATE_COMPLIANCE_REQUIREMENT: '/api/compliance-requirement',
  CREATE_COMPLIANCE_REQUIREMENT: '/api/compliance-requirement',
  GET_COMPLIANCE_REQUIREMENT_STATES: '/api/compliance-requirement/get-states',
  GET_COMPLIANCE_MANAGER_CATEGORIES:
    '/api/compliance-requirement/get-categories',
  GET_COMPLIANCE_REQUIREMENT_BY_SKILL_CHECKLIST:
    '/api/compliance-requirement/skill-checklist',
  GET_COMPLIANCE_REQUIREMENT_BY_COMPETENCY_TEST:
    '/api/compliance-requirement/competency-test',
  GET_COMPLIANCE_REQUIREMENT_BY_REFERENCE_FORM:
    '/api/compliance-requirement/reference-form',
  GET_ALL_COMPLIANCE_REQUIREMENT:
    '/api/compliance-requirement/get-requirements',
  DELETE_COMPLIANCE_REQUIREMENT:
    '/api/compliance-requirement/delete-requirement',

  //COMPLIANCE ENDPOINTS
  UPDATE_COMPLIANCE: '/api/compliance-requirement/compliance',
  CREATE_COMPLIANCE: '/api/compliance-requirement/compliance',
  DELETE_COMPLIANCE: '/api/compliance-requirement/delete-compliance',
  GET_COMPLIANCE_POSITIONS: '/api/compliance-requirement/get-positions',
  GET_COMPLIANCE: '/api/compliance-requirement/user-compliance-document',
  UPDATE_COMPLIANCE_APPROVAL: '/api/compliance-requirement/status-approve',
  DELETE_COMPLIANCE_DOCUMENT: '/api/compliance-requirement/delete-document',
  GET_DOCUMENTS_BY_COMPLIANCE_ID: '/api/compliance-requirement/get-documents',
  UPLOAD_NEW_COMPLIANCE: '/api/compliance-requirement/compliance/link-document',
  GET_COMPLIANCE_REQUIREMENT_CATEGORIES:
    '/api/compliance-requirement/compliance-categories',
  COMPLIANCE_SEND_REMINDER:
    '/api/compliance-requirement/send-compliance-reminder',

  // CAREGIVERS ENDPOINTS
  SEND_INVITE: '/api/caregiver',
  GET_CAREGIVER: '/api/caregiver',
  GET_CAREGIVER_DETAILS: '/api/caregiver',
  UPDATE_CAREGIVER_PERSONAL_DETAILS: '/api/caregiver',
  UPDATE_CAREGIVER_STATUS: '/api/caregiver/archive-status',
  CAREGIVER_SIGNEDOFF_STATUS: '/api/caregiver/signedoff-status',
  UPDATE_CAREGIVER_EDUCATION_HISTORY: '/api/caregiver/education-history',
  UPDATE_CAREGIVER_EMPLOYMENT_HISTORY: '/api/caregiver/employment-history',

  // CAREGIVER DOCUMENT ENDPOINTS
  ADD_CAREGIVER_DOCUMENT: '/api/documents',
  GET_CAREGIVER_DOCUMENTS: '/api/documents',
  UPDATE_CAREGIVER_DOCUMENT: '/api/documents',
  DELETE_CAREGIVER_DOCUMENT: '/api/documents',
  TOGGLE_STATUS_DOCUMENT: '/api/documents/rejected',
  UPLOAD_FILE_DOCUMENT: '/api/documents/upload-document',
  GET_DOCUMENTS_CATEGORY: '/api/documents/get-categories',

  // CAREGIVER ACITVITY ENDPOINTS
  GET_CAREGIVER_ACTIVITIES: '/api/activity-note',
  ADD_CAREGIVER_NOTE: '/api/activity-note/add-note',
  DELETE_CAREGIVER_NOTE: '/api/activity-note/delete-note',
  UPDATE_CAREGIVER_NOTE: '/api/activity-note/update-note',

  // CAREGIVER REFERENCE ENDPOINTS
  GET_CAREGIVER_REFERENCE: '/api/reference-caregiver',
  REFERENCE_PHONE_OVERRIDE: '/api/reference-caregiver',
  REFERENCE_CANCEL_REQUEST: '/api/reference-caregiver/cancelRequest',
  REFERENCE_SEND_REMINDER: '/api/reference-caregiver/reminder-request',
  ADD_CAREGIVER_REFERENCE: '/api/reference-caregiver/request-reference',

  // CHAT SETTINGS ENDPOINTS
  GET_GROUP: '/api/chat/groups',
  CREATE_GROUP: '/api/chat/groups',
  UPDATE_GROUP: '/api/chat/groups',
  DELETE_GROUP: '/api/chat/groups',
  DELETE_CHAT: '/api/chat/delete-chat',
  GET_ALL_CHAT: '/api/chat/all-user-chat',
  GET_CHAT_MESSAGES: '/api/chat/messages',
  GET_USER_GROUPS: '/api/chat/user-groups',
  GET_CHAT_ADMINS: '/api/chat/get-all-admin',
  GET_GROUPS_DROPDOWN: '/api/chat/dropdownGroups',
  GET_CHAT_MEMBERS: '/api/chat/get-all-chat-members',
  CHANGE_GROUP_STATUS: '/api/chat/change-group-status',
  CLOSE_CHAT: '/api/chat/chat-disappear',

  // ONBOARDING ENDPOINTS

  CREATE_ONBOARDING: '/api/onboarding/create-onboarding',
  GET_ONBOARDING_TYPES: '/api/onboarding/onboarding-types',
  POST_ONBOARDING_STEPS: '/api/onboarding/onboarding-steps',
  GET_ADMIN_MEMBERS: '/api/onboarding/get-admin-members',
  GET_ORGANIZATION_MEMBERS: '/api/onboarding/get-organization-users',
  GET_ALL_ONBOARDING: '/api/onboarding/get-onboarding',
  STATUS_CHANGE_ONBOARDING: '/api/onboarding/isactive-onboarding',
  DELETE_ONBOARDING: '/api/onboarding/delete-onboarding',
  GET_DOCUMENT_STEP: '/api/onboarding/documentStep', // positionId
  UPDATE_ONBOARDING: '/api/onboarding/update-onboarding',
  SINGLE_STEP_UPDATE: '/api/onboarding/step',
  SINGLE_STEP_DELETE: '/api/onboarding/step',
  GET_SKILLCHECKLIST_REQUIREMENTS: '/api/onboarding/requirement-skillchecklist',
  GET_COMPETENCY_TEST_REQUIREMENTS:
    '/api/onboarding/requirement-competencytest',
  GET_REFERENCEFORM_REQUIREMENTS: '/api/onboarding/requirement-referenceform',
  DUPLICATE_ONBOARDING: '/api/onboarding/duplicate-onboarding',
  VIEW_ONBOARDING: '/api/onboarding/onboarding-detail',

  // APPLICANT ENDPOINTS
  GET_APPLICANT_ONBOARDING: '/api/applicant-onboarding/onboarding',
  UPLOAD_APPLICANT_DOCUMENT: '/api/applicant-onboarding/document-upload',
  DELETE_APPLICANT_DOCUMENT: '/api/applicant-onboarding/document',
  SUBMIT_COMPETENCY_TEST_ANSWERS: '/api/competency-test/answers',
  SUBMIT_COMPETENCY_TEST_RETAKE: '/api/competency-test/retake',
  SUBMIT_REFERENCE_CHECK: '/api/applicant-onboarding/request-reference',
  GET_APPLICANT_REFERENCES: '/api/applicant-onboarding/applicant-references',
  GET_REFEREE_QUESTIONS: 'api/applicant-onboarding/request-reference',
  SUBMIT_REFEREE_ANSWERS: 'api/reference-form/submit-answers',
  CANCEL_REFEREE_REQUEST: 'api/applicant-onboarding/cancelRequest',
  SUBMIT_SKILL_CHECKLIST_ANSWERS: '/api/skill-checklist/submit-answer',
  SUBMIT_APPLICANT_FORM: '/api/applicant-onboarding/completion-status',
};
